import {Badge, LinedRow, Typography} from '@kaman/uikit';
import {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import BranchCard from './branchCard';
import BranchesListSkeleton from './branchesListSkeleton';
import {setSheetHeader} from '../../../redux/sheetHeader/sheetHeaderSlice';
import {useQuery} from 'react-query';
import {GetStoreInfo} from '../../../services/store.service';
import {useSearchParams} from 'react-router-dom';
import {IBranches} from '../../../models/store.model';

export default function BranchesList() {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const storeId = searchParams.get('storeId');
    const numericStoreId = Number(storeId);
    const isValidStoreId =
        Number.isInteger(numericStoreId) && numericStoreId > 0;

    const {
        data: storeInfo,
        isLoading,
        isError,
    } = useQuery(
        ['store-info', numericStoreId],
        () => GetStoreInfo({storeId: numericStoreId}),
        {enabled: isValidStoreId}
    );
    useEffect(() => {
        dispatch(
            setSheetHeader({
                title: storeInfo?.title || 'شعبه های ما',
                showBack: true,
            })
        );
    }, [dispatch]);

    const handleNavigate = (branch: IBranches) => {
        if (branch.lat == null || branch.lng == null) return;
        const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
        const label = encodeURIComponent(branch.title);
        const mapsUrl = isMobile
            ? `geo:${branch.lat},${branch.lng}?q=${branch.lat},${branch.lng}(${label})`
            : `https://www.google.com/maps?q=${branch.lat},${branch.lng}&q=${label}`;

        if (isMobile) {
            window.location.href = mapsUrl;
        } else {
            window.open(mapsUrl, '_blank');
        }
    };

    if (isLoading) {
        return <BranchesListSkeleton />;
    }

    return (
        <div>
            <LinedRow
                hasBottomBorder={false}
                rightSideNode={
                    <Typography variant="h6">شعبه های ما</Typography>
                }
                leftSideNode={
                    <Badge
                        text={`${storeInfo?.branches.length} شعبه`}
                        variant="outlined"
                        textColor="primary"
                        size="md"
                        className=" border-2 border-primary"
                    />
                }
            />

            <div style={{marginTop: '8px'}}>
                {storeInfo?.branches.map((branch, index) => (
                    <BranchCard
                        key={branch.title}
                        title={branch.title}
                        address={branch.address}
                        hasBottomBorder={
                            index !== storeInfo?.branches.length - 1
                        }
                        onNavigate={() => handleNavigate(branch)}
                    />
                ))}
            </div>
        </div>
    );
}
